import { computed, useSlots } from 'vue';

export function useTableFilters(appliedFilters) {
  const slots = useSlots();
  const shouldRenderTableFilters = computed(() => {
    return (typeof appliedFilters?.value === 'object' && appliedFilters.value !== null)
            || slots['custom-filters']?.();
  });

  return { shouldRenderTableFilters };
}
